import { useAuth } from "@/auth/AuthContext";
import { useLocalStore } from "@/contexts/LocalStoreContext";
import { useAreaManagerSession } from "@/contexts/AreaManagerSessionContext";
import { normalizeStoreId } from "@/lib/offlineCart";

function getStoreIdFromUrl() {
  try {
    if (typeof window === "undefined") return null;
    return new URLSearchParams(window.location.search).get("storeId")?.trim() || null;
  } catch {
    return null;
  }
}

/**
 * סניף פעיל — store_id של מנהל סניף, או actingStore של מנהל אזור.
 * ענף פעיל — מ־user.branch_id (סל/הערות נפרדים תחת אותו סניף).
 */
export function useStoreSession() {
  const { user } = useAuth();
  const { storeId: localStoreId } = useLocalStore();
  const { isAreaManager, isActingAsStore, actingStoreId } = useAreaManagerSession();
  const urlStoreId = getStoreIdFromUrl();

  const storeId = normalizeStoreId(
    (isAreaManager ? urlStoreId : null) ??
      localStoreId ??
      (isActingAsStore ? actingStoreId : null) ??
      (isAreaManager ? null : (user?.store_id?._id ?? user?.store_id)) ??
      null
  );

  const branchId = normalizeStoreId(user?.branch_id?._id ?? user?.branch_id ?? null);

  const roleKey = user?.role?.key || user?.role;
  const isBranchStaff =
    !!user?.isSuperAdmin ||
    isActingAsStore ||
    (isAreaManager && !!storeId) ||
    ["SUPER_MANAGER", "STORE_MANAGER", "store_manager", "SUPER_USER"].includes(roleKey);

  const cartAccess = user?.isSuperAdmin
    ? "edit"
    : isActingAsStore
      ? "edit"
      : isAreaManager && storeId
        ? "edit"
      : user?.modules_access?.cart || "none";

  return {
    user,
    storeId,
    branchId: branchId || "",
    isActingAsStore,
    isBranchStaff,
    cartAccess,
    canEditCart: cartAccess === "edit",
    hasStoreSession: !!storeId,
  };
}
